<div class="c-content c-content--scroll c-content--fit">
	<div *ngFor="let group of vm.groups" [ngSwitch]="group.type" [ngStyle]="!vm.initialized && { visibility: 'hidden' }">
		<div class="c-divider c-divider--h" *ngSwitchCase="'divider'" [attr.data-label]="group.label"></div>
		<item-message-group [group]="group" [chat]="vm.chat" [lastSeen]="vm.lastSeenPostId" *ngSwitchDefault></item-message-group>
	</div>
	<div *ngFor="let group of vm.pendingGroups">
		<item-message-group [group]="group" [chat]="vm.chat"></item-message-group>
	</div>
	<div class="c-message c-message--left" *ngIf="vm.chat && vm.isOtherTyping[vm.chat.id] === true">
	    <div class="c-message__content c-message__content--typing" style="padding: 12px 15px;">
	        <div class="c-message__row">
				<div class="c-dots-3">
				    <div class="c-dots-bounce-1"></div>
				    <div class="c-dots-bounce-2"></div>
				    <div class="c-dots-bounce-3"></div>
				</div>
	        </div>
	    </div>
	</div>
	<loader-overlay *ngIf="vm.loading || !vm.initialized" [theme]="5"></loader-overlay>
</div>
<div class="c-content c-content--footer u-no-p" [ngStyle]="!vm.initialized && { visibility: 'hidden' }">
	<div class="c-content" *ngIf="vm.notification && !vm.notification.hidden && !vm.loading && !vm.isInfoHidden">
		<item-notification icon="{{vm.notification.icon}}" [text]="vm.notification.text" [btnText]="vm.notification.btnText" [action]="vm.notification.action" [narrow]="true"></item-notification>
	</div>
	<div class="c-content c-content--slim c-content--border-top" *ngIf="vm.chat && !vm.chat.disabled && !vm.serviceProviderAiChatActive">
		<input-messenger [group]="vm.groups" [(chat)]="vm.chat" [isPopup]="vm.isPopup"></input-messenger>
	</div>
	<div class="c-content c-content--md c-content--border-top" *ngIf="vm.chat && vm.chat.disabled">
		<div id="chatDisabledSpecialistLabel" *ngIf="vm.user?.businessUserType === 'SERVICE_PROVIDER'" class="c-text c-text--sm c-text--s5">
			{{ 'Condition_Summary.Chat_Disabled_Info_Specialist' | translate }}
		</div>
		<div id="chatDisabledPatientLabel" *ngIf="!vm.user?.businessUser" class="c-text c-text--sm c-text--s5">
			{{ 'Condition_Summary.Chat_Disabled' | translate }}
		</div>
	</div>
	<div class="c-content c-content--md c-content--border-top" *ngIf="vm.serviceProviderAiChatActive">
		<div id="chatDisabledAiActiveLabel" class="c-text c-text--sm c-text--s5">
			{{ 'Chats.Other.Ai_Chat_Active' | translate }} <a style="cursor:pointer;" (click)="vm.disableChatBot()">{{ 'Chats.Other.Ai_Chat_Take_Over' | translate }}</a>
		</div>
	</div>
</div>
